import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  COOKIES,
  LARAVEL_APP_API,
  LARAVEL_APP_HOST,
  LARAVEL_APP_VERSION,
  SCREEN_PATHS,
} from "../constants";
import { CognitoAuth } from "./CognitoAuth";
import { Invites } from "./Invites";
import { AtticusEstate } from "./AtticusEstate";
import { FinancialConvoAPI } from "./FinancialConvoAPI";
import { ProbateAPI } from "./ProbateAPI";
import { FormsAPI } from "./FormsAPI";
import { DocumentsAPI } from "./DocumentsAPI";
import { EstateFormsAPI } from "./EstateFormsAPI";
import { Geographies } from "./Geographies";
import Cookies from "js-cookie";
import { getCasperInfo } from "../components/CasperBanner";

export const laravelApiV1 = LARAVEL_APP_HOST + LARAVEL_APP_API + "/v1";
export const laravelApiV2 = LARAVEL_APP_HOST + LARAVEL_APP_API + LARAVEL_APP_VERSION;
export const axiosInstance = axios.create({ // API singletons
  baseURL: laravelApiV2,
});
export const CancelToken = axios.CancelToken;
export const log2Console = process.env.NODE_ENV === "development";
export const authApi = new CognitoAuth(axiosInstance);
export const estateApi = new AtticusEstate();
export const financialConvoApi = new FinancialConvoAPI();
export const probateApi = new ProbateAPI();
export const formsApi = new FormsAPI();
export const estateFormsApi = new EstateFormsAPI();
export const inviteApi = new Invites();
export const documentsAPI = new DocumentsAPI();
export const delay = (ms: number): Promise<void> => new Promise((res) => setTimeout(res, ms));
export const geographiesApi = new Geographies();

function headersPlusAuth(currentHeaders?: any): any {
  const headers: any = currentHeaders || {}

  const authToken = Cookies.get(COOKIES.authToken)
  if (authToken) {
    headers.Authorization = "Bearer " + Cookies.get(COOKIES.authToken)
  }


  const casperInfo = getCasperInfo()
  if (casperInfo) {
    headers["X-Acting-As"] = casperInfo.userId
  }

  return headers
}

export async function callGet(
  path: string,
  rethrowError = false,
  config?: AxiosRequestConfig
): Promise<AxiosResponse | null> {
  let result = null
  try {
    result = await axiosInstance.get(path, { ...config, headers: headersPlusAuth(config?.headers), });
  } catch (error) {
    if (rethrowError) {
      throw error;
    } else {
      handleError(error);
    }
  } finally {

  }

  return result;
}

export async function callPostWithFormData(
  path: string,
  formData?: FormData,
  rethrowError = false,
  config?: AxiosRequestConfig
): Promise<AxiosResponse | null> {
  let result = null
  try {
    result = await axiosInstance.post(path, formData, { ...config, headers: headersPlusAuth(config?.headers), });
  } catch (error) {
    if (rethrowError) {
      throw error;
    } else {
      handleError(error);
    }
  } finally {

  }
  return result;
}

export async function callPost(
  path: string,
  body?: Record<string, unknown>,
  rethrowError = false,
  config?: AxiosRequestConfig
): Promise<AxiosResponse | null> {
  let result = null
  try {
    result = await axiosInstance.post(path, body, { ...config, headers: headersPlusAuth(config?.headers), });
  } catch (error) {
    if (rethrowError) {
      throw error;
    } else {
      handleError(error);
    }
  } finally {

  }
  return result;
}

export async function callPut(
  path: string,
  body?: Record<string, unknown>,
  rethrowError = false,
  config?: AxiosRequestConfig
): Promise<AxiosResponse | null> {
  let result = null
  try {
    result = await axiosInstance.put(path, body, { ...config, headers: headersPlusAuth(config?.headers), });
  } catch (error) {
    if (rethrowError) {
      throw error;
    } else {
      handleError(error);
    }
  } finally {

  }

  return result;
}

export async function callDelete(
  path: string,
  rethrowError = false,
  config?: AxiosRequestConfig
): Promise<AxiosResponse | null> {
  let result = null
  try {
    result = await axiosInstance.delete(path, { ...config, headers: headersPlusAuth(config?.headers), });
  } catch (error) {
    if (rethrowError) {
      throw error;
    } else {
      handleError(error);
    }
  } finally {

  }
  return result;
}

function handleError(error: any) {
  if ((error as any)?.response?.status === 401) {
    console.log("user failed authentication for an API call, signing user out")
    // user not authenticated
    window.document.location.href = SCREEN_PATHS.signOut;
    // TODO: add path to redirect back to once logged in
  } else if ((error as any)?.response?.status === 503) {
    // service unavailable, come back later
    window.document.location.href = SCREEN_PATHS.maintenance;
  } else {
    const errorObject = {
      message: (error as Error)?.message,
      baseURL: error?.config?.baseURL,
      url: error?.config?.url,
      method: error?.config?.method,
    };
    console.error(errorObject);
  }
}

/**
 * artificial delay for testing
 * @param milliseconds
 */
export async function addDelay(milliseconds = 500): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
}